export default __webpack_public_path__ + "static/media/shutterstock_682962715_BIBLIOGRAFIA_small.97ea6083.webp";